export { UniProfileBanner } from "./../uni_profile_banner";
export { UniProfileLinks } from "./../uni_profile_links";
export { UniOverviewAbout } from "./uni_overview_about";
export { UniOverviewRanking } from "./uni_overview_ranking";
export { UniOverviewAccomodation } from "./uni_overview_accomodation";
export { UniProfileUniBox } from "./../uni_profile_uni_box";
export { UniOverview } from "./uni_overview";
export { UniOverviewAdmission } from "./uni_overview_admission";
export { UniOverviewScholarship } from "./uni_overview_scholarship";
export { UniOverviewCourses } from "./uni_overview_courses";
export { UniOverviewCampus } from "./uni_overview_campus";
export { UniOverviewPopularUniversity } from "./uni_overview_popular_university";
